import { render, staticRenderFns } from "./OnboardedHome.vue?vue&type=template&id=2de73a18&scoped=true"
import script from "./OnboardedHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardedHome.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OnboardedHome.vue?vue&type=style&index=0&id=2de73a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de73a18",
  null
  
)

export default component.exports